<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.88638 10.6574C7.89975 10.6744 7.91682 10.6883 7.93631 10.6977C7.9558 10.7072 7.9772 10.7122 7.99888 10.7122C8.02057 10.7122 8.04196 10.7072 8.06146 10.6977C8.08095 10.6883 8.09802 10.6744 8.11138 10.6574L10.1114 8.12701C10.1846 8.03415 10.1185 7.89665 9.99888 7.89665H8.67567V1.85379C8.67567 1.77522 8.61138 1.71094 8.53281 1.71094H7.46138C7.38281 1.71094 7.31853 1.77522 7.31853 1.85379V7.89487H5.99888C5.87924 7.89487 5.81317 8.03237 5.88638 8.12522L7.88638 10.6574ZM14.5346 10.0324H13.4632C13.3846 10.0324 13.3203 10.0967 13.3203 10.1752V12.9252H2.67746V10.1752C2.67746 10.0967 2.61317 10.0324 2.5346 10.0324H1.46317C1.3846 10.0324 1.32031 10.0967 1.32031 10.1752V13.7109C1.32031 14.027 1.57567 14.2824 1.89174 14.2824H14.106C14.4221 14.2824 14.6775 14.027 14.6775 13.7109V10.1752C14.6775 10.0967 14.6132 10.0324 14.5346 10.0324Z"
      :fill="color"
      fill-opacity="0.85"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color:{
      type: String,
      default: "black",
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// Download.vue?30c96494